import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { AreaDeleteComponent } from './area-delete.component';
import { AreaDeleteUsersAndUnitsOptionsCardComponent } from './area-delete-users-and-units-options-card/area-delete-users-and-units-options-card.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FormsModule } from '@angular/forms';
import { AreaDeleteIntroductionCardComponent } from './area-delete-introduction-card/area-delete-introduction-card.component';
import { AreaDeleteTransferCardComponent } from './area-delete-transfer-card/area-delete-transfer-card.component';
import { AreaDeleteAreaContentOptionsCardComponent } from './area-delete-area-content-options-card.component/area-delete-area-content-options-card.component';
import { AreaDeleteSelectOwnerCardComponent } from './area-delete-select-owner-card/area-delete-select-owner-card.component';
import { AreaDeleteConfirmationCardComponent } from './area-delete-confirmation-card/area-delete-confirmation-card.component';
import { AreaDeleteUserContentOptionsCardComponent } from './area-delete-user-content-options-card/area-delete-user-content-options-card.component';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatRadioModule,
        MatSelectModule,
        MatInputModule,
        FormsModule,
        UtilitiesModule,
    ],
    declarations: [
        AreaDeleteComponent,
        AreaDeleteIntroductionCardComponent,
        AreaDeleteUsersAndUnitsOptionsCardComponent,
        AreaDeleteTransferCardComponent,
        AreaDeleteAreaContentOptionsCardComponent,
        AreaDeleteSelectOwnerCardComponent,
        AreaDeleteConfirmationCardComponent,
        AreaDeleteUserContentOptionsCardComponent,
    ],
})
export class AreaDeleteModule {}
